"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.initialValues = exports.icon = exports.getMetrics = exports.getDataDefinitions = exports.fields = void 0;
var _react = _interopRequireDefault(require("react"));
var _round2 = _interopRequireDefault(require("lodash/round"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var fields = exports.fields = ['type', 'id', 'playOnStart', 'loop', 'mustWatch', 'mustWatchMessage', 'autoAdvance', 'controls', 'volume', 'playbackRate', 'width', 'height', 'size', 'aspectRatio', 'audio', 'spriteHandle', 'startAnimationLabel', 'idleAnimationLabel', 'origin', 'marginOverride', 'marginValX', 'marginValY',
// settings open
'settingsOpen', 'advancedOpen'];
var initialValues = exports.initialValues = {
  type: 'vimeo',
  id: '',
  playOnStart: false,
  loop: false,
  controls: true,
  mustWatch: false,
  mustWatchMessage: 'You must watch the entire video.',
  autoAdvance: false,
  volume: 0.8,
  playbackRate: 1,
  width: '100%',
  height: 'auto',
  size: 'large',
  aspectRatio: '16/9',
  audio: '<p>Add audio file here...</p>',
  spriteHandle: 'default',
  startAnimationLabel: 'startAnimation',
  idleAnimationLabel: 'idleAnimation',
  origin: 'TC',
  marginOverride: false,
  marginValX: 0,
  marginValY: 0,
  settingsOpen: true,
  advancedOpen: false
};
var icon = exports.icon = /*#__PURE__*/_react["default"].createElement("i", {
  className: "glyphicon glyphicon-facetime-video"
});
var validate = exports.validate = function validate(values) {
  var errors = {};
  if (values.volume === null || values.volume === '' || values.volume < 0 || values.volume > 1) {
    errors.volume = 'Volume must be between 0 and 1.';
  }
  if (values.playbackRate === null || values.playbackRate === '' || values.playbackRate < 0 || values.playbackRate > 1) {
    errors.playbackRate = 'Rate must be between 0 and 1.';
  }
  if (values.type !== 'sprite' && (values.id === null || values.id === '')) {
    errors.id = 'Id or url is required.';
  }
  if (values.type === 'file' && values.id) {
    var regex = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/;
    if (!regex.test(values.id)) {
      errors.id = 'Valid URL is required';
    }
  }
  return errors;
};
var getDataDefinitions = exports.getDataDefinitions = function getDataDefinitions(id, settings) {
  var isMatrix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var title = "".concat(settings.type, " ").concat(settings.id);
  return _defineProperty(_defineProperty(_defineProperty({}, id + '_ended', {
    title: title,
    titleHtml: title,
    subtitle1: 'True if user watched video to end.',
    subtitle1Html: 'True if user watched video to end.',
    type: 'boolean',
    questionType: 'video',
    tags: {
      system: ['meta']
    }
  }), id + '_played', {
    title: title,
    titleHtml: title,
    subtitle1: 'Percent of video played.',
    subtitle1Html: 'Percent of video played.',
    type: 'number',
    questionType: 'video',
    tags: {
      system: ['meta']
    }
  }), id + '_playedSeconds', {
    title: title,
    titleHtml: title,
    subtitle1: 'Time in seconds of video played.',
    subtitle1Html: 'Time in seconds of video played.',
    type: 'number',
    questionType: 'video',
    tags: {
      system: ['meta']
    }
  });
};
var getMetrics = exports.getMetrics = function getMetrics(id, settings, answer) {
  if (answer === undefined) {
    answer = {
      ended: null,
      played: null,
      playedSeconds: null
    };
  }
  return _defineProperty(_defineProperty(_defineProperty({}, id + '_ended', answer.ended), id + '_played', (0, _round2["default"])(answer.played, 2)), id + '_playedSeconds', (0, _round2["default"])(answer.playedSeconds, 2));
};